import config from '../config/config.json';

export default class UserService {

  static apiRelativePath = "/users"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  changePassword = async (data) => {
    return this.apiClient.post(`${UserService.apiRelativePath}/me/password`, data);
  }

  updateProfile = async (data) => {
    return this.apiClient.patch(`${UserService.apiRelativePath}/me`, data);
  }

  getActions = async () => {
    return this.apiClient.get(`${UserService.apiRelativePath}/me/actions`);
  }

  forgotPassword = async (data) => {
    let options = {
      headers: {
        Authorization: 'Basic ' + btoa(config.basicAuthUserName + ":" + config.basicAuthUserPassword)
      }
    }
    return this.apiClient.post(`${UserService.apiRelativePath}/forgot-password`, data, options);
  }

  resetPassword = async (data) => {
    let options = {
      headers: {
        Authorization: 'Basic ' + btoa(config.basicAuthUserName + ":" + config.basicAuthUserPassword)
      }
    }
    return this.apiClient.post(`${UserService.apiRelativePath}/reset-password`, data, options);
  }
}
